import Vue from 'vue'
import ECircularLoading from '../components/ECircularLoading/ECircularLoading'

/* @vue/component */

export default Vue.extend().extend({
  name: 'loadable',
  props: {
    loading: {
      type: [Boolean, String],
      default: false,
    },
  },
  methods: {
    genProgress() {
      if (this.loading === false) return null
      return (
        this.$slots.progress ||
        this.$createElement(ECircularLoading, {
          props: {
            color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
            indeterminate: true,
          },
        })
      )
    },
  },
})
